import { render, staticRenderFns } from "./ChatCompOrder.vue?vue&type=template&id=48bb24a5"
import script from "./ChatCompOrder.vue?vue&type=script&lang=js"
export * from "./ChatCompOrder.vue?vue&type=script&lang=js"
import style0 from "./ChatCompOrder.vue?vue&type=style&index=0&id=48bb24a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports